import React from "react";

const OperationsandSuppliers1 = () => {
  return (
    <div className="container mx-auto">
       <div className="flex justify-between">
        <h1 className="mx-4 pb-8 text-gray-500 text-xl font-bold">
        Operations and suppliers at significant risk for incidents of child
        labor
        </h1>
        <h3 className="text-end mx-8 bg-gray-200 font-bold text-sm h-[3%] border-4 h-12 w-[10%]">
          GRI 408-1
        </h3>
      </div>
      <table className="border-collapse border mx-4 ">
        <tr>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Operations considered to have significant risk of child labor
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Type of Operation
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Countries or Geographic Areas
          </th>
        </tr>
        <tr>
          {/* <th className="border text-xs font-bold px-4 py-4">Male</th>
          <th className="border text-xs font-bold px-4 py-4">Female</th>
          <th className="border text-xs font-bold px-4 py-4">Non-Binary</th> */}
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            Operation
          </td>
          <td className=" px-1 py-2 text-xs">
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="8"
            ></input>
          </td>
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            +Add Category
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="12"
            ></input>
          </td>
        </tr>
      </table>

      <p className="text-xs italic font-bold mt-10 mx-4">
        Operations at significant risk for incidents of young workers exposed to
        hazardous work
      </p>
      <table className="border-collapse border mx-4 ">
        <tr>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Operations considered to have significant risk of young workers
            exposed to hazardous work
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Type of Supplier
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Countries or Geographic Areas
          </th>
        </tr>
        <tr>
          {/* <th className="border text-xs font-bold px-4 py-4">Male</th>
          <th className="border text-xs font-bold px-4 py-4">Female</th>
          <th className="border text-xs font-bold px-4 py-4">Non-Binary</th> */}
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            Supplier
          </td>
          <td className=" px-1 py-2 text-xs">
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="8"
            ></input>
          </td>
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            +Add Category
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="12"
            ></input>
          </td>
        </tr>
      </table>
      <p className="text-xs italic font-bold mt-10 mx-4">
        Suppliers at significant risk for incidents of child labor
      </p>
      <table className="border-collapse border mx-4 ">
        <tr>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Suppliers considered to have significant risk of child labor
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Type of Supplier
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Countries or Geographic Areas
          </th>
        </tr>
        <tr>
          {/* <th className="border text-xs font-bold px-4 py-4">Male</th>
          <th className="border text-xs font-bold px-4 py-4">Female</th>
          <th className="border text-xs font-bold px-4 py-4">Non-Binary</th> */}
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            Supplier
          </td>
          <td className=" px-1 py-2 text-xs">
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="8"
            ></input>
          </td>
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            +Add Category
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="12"
            ></input>
          </td>
        </tr>
      </table>
      <p className="text-xs italic font-bold mt-10 mx-4">
        Suppliers at significant risk for incidents of young workers exposed to
        hazardous work
      </p>
      <table className="border-collapse border mx-4 ">
        <tr>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Suppliers considered to have significant risk of young workers
            exposed to hazardous work
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Type of Supplier
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[30%] py-2">
            Countries or Geographic Areas
          </th>
        </tr>
        <tr>
          {/* <th className="border text-xs font-bold px-4 py-4">Male</th>
          <th className="border text-xs font-bold px-4 py-4">Female</th>
          <th className="border text-xs font-bold px-4 py-4">Non-Binary</th> */}
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            Supplier
          </td>
          <td className=" px-1 py-2 text-xs">
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="8"
            ></input>
          </td>
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            +Add Category
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="12"
            ></input>
          </td>
        </tr>
      </table>
      <div className="flex items-center mx-4 pb-2 mb-4 mt-8">
        <div className="w-full mr-2">
          <label htmlFor="legalForm" className="block font-bold mb-1 pb-2">
            <h2 className="text-gray-600">
              {" "}
              Specify details about the measures taken by the organization to
              contribute to the effective abolition of child labor
            </h2>
          </label>
          <textarea
            id="countriesOfOperation"
            name="countriesOfOperation"
            placeholder="Enter a text"
            className="mt-2 p-2 border rounded-md w-full"
            // value={formData.countriesOfOperation}
            // onChange={handleInputChange}
            rows={4} // Specify the number of rows to determine the initial height
          />
        </div>
      </div>
    </div>
  );
};

export default OperationsandSuppliers1;
